import utilities from '@/services/utilities/utilities';

export default class FiveCardHandsCategory {
  get flatArrayOfLeaves() {
    let flatArrayOfLeaves = [];

    this.forEachLeaf(function (leaf) {
      flatArrayOfLeaves.push(leaf);
    });

    return flatArrayOfLeaves;
  };
  get flatArrayOfParents() {
    let flatArrayOfParents = [];

    this.forEachParent(function (leaf) {
      flatArrayOfParents.push(leaf);
    });

    return flatArrayOfParents;
  };

  forEachNode(cb) {
    utilities.general.forEachNode(this.data, cb);
  };
  forEachLeaf(cb) {
    utilities.general.forEachLeaf(this.data, cb);
  };
  forEachParent(cb) {
    utilities.general.forEachParent(this.data, cb);
  };
  forEachVisibleLeaf(cb) {
    this.forEachLeaf(function (leaf) {
      if (leaf.visible) {
        cb(leaf);
      }
    });
  };
  forEachCheckedLeaf(cb) {
    this.forEachLeaf(function (leaf) {
      if (leaf.visible && leaf.checked) {
        cb(leaf);
      }
    });
  };
  setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck) {
    this.forEachLeaf(function (fiveCardHandLeaf) {
      fiveCardHandLeaf.setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck);
    });
  };
  setBreadcrumbText() {
    this._setBreadcrumbTextOnArray(this.data);
  };
  _setBreadcrumbTextOnArray(array, parentBreadcrumbText) {
    array.forEach(function (node) {
      if (parentBreadcrumbText) {
        node.breadcrumbText = parentBreadcrumbText + ' | ' + node.text;
      } else {
        node.breadcrumbText = node.text;
      }

      if (node.children) {
        this._setBreadcrumbTextOnArray(node.children, node.breadcrumbText);
      }
    }, this);
  };
};



// WEBPACK FOOTER //
// ./src/services/five-card-hands/categories/FiveCardHandsCategory.js